module.exports = __webpack_public_path__ + "static/media/vipImage.b63147a0.png";